// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}.appZone{color:var(--font-color);font-family:var(--font-family)}.btn,.btn:active,.btn:hover{background-color:var(--btn_bg_color);color:var(--btn_color);border-color:var(--btn_bg_color)}.btn:hover{opacity:.8}.btn,.custom-select,.form-control{font-size:16px}", ""]);
// Exports
module.exports = exports;
